module.exports = {
	"account.user.driving.licence.already.exist": "Es gibt ein anderes Konto mit dieser Führerscheinnummer.",
	"account.user.login.already.exist": "Diese E-Mail-Adresse wird bereits von einem anderen Konto verwendet.",
	"account.user.suspended": "Diese Aktion kann nicht ausgeführt werden, da der Benutzer angehalten ist",
	"action.add.payment": "Zahlungsmethode hinzufügen",
	"action.complete.my.account": "Vervollständige mein Konto",
	"action.confirm.welcome.msg": "Lass uns gehen",
	"action.create.my.account": "Mein Konto erstellen",
	"action.search.update.bookings": "Verfügbarkeiten überprüfen",
	"action.update.payment": "Zahlungsmethode aktualisieren",
	"anonymous.search.location.not.available": "The search is not available for this location",
	"booking.accept_usage_terms.link.label": "Terms of use",
	"booking.accept_usage_terms.text": "Indem Sie auf «Bestätigen» klicken, geben Sie Ihr Ehrenwort, dass Sie die allgemeinen Geschäftsbedingungen akzeptieren und derzeit einen gültigen Führerschein besitzen. Mehr im {link}.",
	"booking.accept_usage_terms.title": "Nutzungsbedingungen",
	"booking.action.cancel.forbidden": "Sie können die Buchung nicht mehr stornieren",
	"booking.action.edit.forbidden": "Sie können eine Buchung nicht mehr bearbeiten",
	"booking.add.calendar": "Zum Kalender hinzufügen",
	"booking.confirm": "Buchung bestätigen",
	"booking.confirm_and_pay": "Bestätigen und zahlen",
	"booking.deposit": "Kaution",
	"booking.deposit.b": "Wenn Sie Ihre Reservierung bestätigen, wird eine Bankkaution in Höhe von {damageSafetyDeposit} {currency}\n Diese Kaution kann verwendet werden, um eventuelle Schäden am Fahrzeug während Ihrer Reise zu decken. \n\n Wenn das Fahrzeug ohne Schäden oder Überstunden zurückgegeben wird, wird nur der Preis von {bookingPrice} {currency} berechnet.",
	"booking.deposit.d": "Wenn Sie Ihre Reservierung bestätigen, wird eine Banküberweisung in Höhe von {bufferPrice} {currency}\n Dies beinhaltet den Preis Ihrer Reservierung und eine Gebühr für eventuelle Überschreitungen. \n\n Ohne Überschreitung oder Fahrzeugschaden wird nur {bookingPrice} {currency} von Ihrem Konto abgebucht.",
	"booking.deposit.db": "Wenn Sie Ihre Reservierung bestätigen, werden zwei Banküberweisungen fällig:\n — Der erste Betrag in Höhe von {bufferPrice} {currency} , einschließlich des Preises Ihrer Reservierung und einer Gebühr zur Deckung etwaiger Überschreitungen.\n — Zweite in Höhe von {damageSafetyDeposit} {currency} , um alle Schäden zu decken, die während Ihrer Reservierung am Fahrzeug verursacht wurden. \n\n Ohne Überschreitung oder Fahrzeugschaden wird nur {bookingPrice} {currency} berechnet.",
	"booking.deposit.info": "Für Ihre Buchung wird eine Anzahlung geleistet",
	"booking.payment.prebilling.refused.error": "Die Transaktion wurde abgelehnt, weil die Belastung Ihrer Kreditkarte fehlgeschlagen ist. Bitte wiederholen Sie die Transaktion mit einer anderen Karte. Falls das Problem weiterhin besteht, wenden Sie sich bitte an Ihre Bank.",
	"booking.payment.prebilling.technical.error": "Beim Zahlungsvorgang ist ein Fehler aufgetreten. Bitte versuchen Sie es später erneut.",
	"booking.success.sub.title": "Danke für die Nutzung unseres Dienstes!",
	"booking.success.title": "Glückwunsch, Ihre Buchung wurde erfolgreich erstellt!",
	"booking.type.label": "Buchungsart",
	"booking.type.one_way": "Nur Hinfahrt",
	"booking.type.return_trip": "Hin- und Rückfahrt",
	"booking.update.period.expired": "Der Zeitraum für die Aktualisierung der Buchungsdaten ist abgelaufen",
	"booking.usage.business": "Geschäftlich",
	"booking.usage.private": "Privat",
	"booking.view_payment_terms.title": "Zahlungsbedingungen",
	"booking.voucher.different.code": "Sie können Ihren Aktionscode nicht ändern",
	"booking.voucher.placeholder": "Ich habe einen Gutscheincode",
	"car.AUTOMATIC": "Automatikgetriebe",
	"car.DIESEL": "Diesel",
	"car.ELECTRIC": "Elektro",
	"car.FOLDING_SEATS": "Klappsitze",
	"car.GPS": "GPS",
	"car.HYBRID": "Hybrid",
	"car.LPG": "GPL",
	"car.MANUAL": "Schaltgetriebe",
	"car.PETROL": "Benziner",
	"car.RADIO_CD": "Radio",
	"car.booking_details": "Buchungsdaten",
	"car.color": "Farbe",
	"car.compact_cars": "Kleinwagen",
	"car.description": "Description",
	"car.details": "Fahrzeugangaben",
	"car.doors": "Türen",
	"car.filter.COMMERCIAL": "Kommerziell",
	"car.filter.PASSENGER": "Tourismus",
	"car.filter.accessories.air_conditioning": "Klimaanlage",
	"car.filter.accessories.baby_seat": "Baby seat",
	"car.filter.accessories.bluetooth": "Bluetooth",
	"car.filter.accessories.large_truck": "Großer LKW",
	"car.filter.accessories.radio_cd": "Radio",
	"car.filter.label_nb_persons": "Personenzahl",
	"car.filter.other": "Sonstiges",
	"car.filter.other-nb": "Andere - {nb}",
	"car.filter.vehicle_type": "Fahrzeugtyp",
	"car.filter_energy": "Energie",
	"car.filter_gearbox_type": "Getriebetyp",
	"car.filter_persons": "Personen",
	"car.for_every_additional_km": "Pro zusätzlichem Kilometer",
	"car.km_included": "KM enthalten",
	"car.motorization": "Motorisierung",
	"car.options": "Optionen",
	"car.parking_additional_info": "Parkplatzdetails",
	"car.places": "Sitze",
	"car.pricing": "Preise",
	"car.pricing.estimate": "Preisschätzung",
	"car.pricing.extra_km_cost_per_day": "Preis pro Zusatz-Km",
	"car.pricing.free_km_per_day": "Km enthalten / 24 Std.",
	"car.specifications": "Spezifikationen",
	"car.transmission": "Schaltung",
	"car.utility_cars": "Nutzfahrzeug",
	"car.version": "Ausführung",
	"company.id.missing.booking.search": "Die Firmen-ID ist für die anonyme Buchungssuche obligatorisch",
	"contact_page.phone_call_price": "(KOSTENLOSER ANRUF AUS DEM FESTNETZ)",
	"contact_page.title_1": "Bei Fragen bezüglich Ihrer Fahrzeuganmietung,",
	"contact_page.title_2": "zögern Sie nicht, uns per E-Mail zu kontaktieren.",
	"creditcard.data.insufficient.3ds": "Aufgrund neuer 3DS2-Anforderungen bitten wir Sie, Ihre Zahlungsinformationen zu aktualisieren.",
	"custom.field.type.boolean": "Ja/Nein",
	"data.with.colon": "{data}:",
	"document.issue.date": "Ausstellungsdatum",
	"dropzone.inner.info": "Zulässige Dateiformate: JPEG, PNG, PDF",
	"dropzone.inner.title": "Laden Sie Ihr Dokument hoch",
	"error.booking.member_invalid": "Ihr Profil ist noch nicht bestätigt worden.",
	"error.booking.no.usage": "Keine Verwendung für diese Buchungsdaten",
	"error.booking.no_credit_card": "Bitte fügen Sie zuerst Ihre Kreditkartendaten hinzu.",
	"error.booking.same_period": "Sie haben bereits eine Buchung für diesen Zeitraum geplant.",
	"error.change_password.400.bad_request": "Passwort ist falsch",
	"error.contract.inactive": "Der Dienst ist für Ihr Unternehmen nicht aktiv. Bitte wenden Sie sich an Ihren Serviceleiter.",
	"error.contract.not-found": "Der Dienst wurde von Ihrem Unternehmen ausgesetzt. Bitte wenden Sie sich an Ihren Serviceleiter.",
	"error.credit.card.refused": "Kreditkarte abgelehnt",
	"error.forgot_password.404": "Bitte überprüfen Sie Ihre E-Mail, kein Konto stimmt überein",
	"error.form.email.already_exists": "Bitte geben Sie eine andere E-Mail-Adresse ein",
	"error.form.email_invalid": "Bitte geben Sie eine gültige E-Mail-Adresse ein",
	"error.form.inviteCode.notEmpty": "Bitte geben Sie einen Einladungscode an",
	"error.form.password.at_least": "Ihr Passwort muss mindestens 8 Zeichen lang sein",
	"error.form.password.at_most": "Ihr Passwort darf maximal 25 Zeichen enthalten",
	"error.form.password.cannot_reset_same": "Ihr neues Passwort muss sich vom derzeitigen unterscheiden",
	"error.form.password.digit": "Ihr Passwort muss 1 Zahl enthalten",
	"error.form.password.lower_letter": "Ihr Passwort muss 1 Kleinbuchstaben enthalten",
	"error.form.password.upper_letter": "Ihr Passwort muss 1 Großbuchstaben enthalten",
	"error.form.password_confirmation.the_same": "Bitte geben Sie zweimal dasselbe Passwort ein",
	"error.form.password_old.the_same": "Das neue Passwort muss sich von den zuvor verwendeten Passwörtern unterscheiden",
	"error.form.required": "Bitte füllen Sie alle Pflichtfelder aus",
	"error.form.suggestion.address.required": "Bitte wählen Sie die Adresse aus der Vorschlagsliste aus",
	"error.form.technical": "Technischer Fehler",
	"error.get.site.config": "Fehler beim Laden der Site-Konfiguration",
	"error.invite.code.invalid": "Die Community, der Sie beitreten möchten, existiert nicht",
	"error.login.401.unauthorized": "Ihre E-Mail-Adresse oder Ihr Passwort sind falsch",
	"error.login.403.user.anonymized": "Ihr Konto wird anonymisiert. Sie können es nicht mehr nutzen",
	"error.login.422.user.not.enabled": "Ihr Konto ist nicht aktiviert. Bitte überprüfen Sie Ihre E-Mails und befolgen Sie die Anleitungen, um Ihr Konto zu aktivieren.",
	"error.number.above.max": "Der Wert kann nicht über {value} liegen",
	"error.number.below.min": "Der Wert kann nicht unter {value} liegen",
	"error.phone.format.invalid": "Das Format der Telefonnummer ist falsch",
	"error.register.without.sso": "You can only subscribe using SSO",
	"error.request_error": "Anfragefehler",
	"error.reset_password.401": "Der bereitgestellte Link ist nicht mehr gültig, bitte fordern Sie ein weiteres Passwort auf der Seite an",
	"error.search.vehicles.403": "Sie können mit dem aktuellen aktiven Profil nicht auf die ausgewählte Site zugreifen",
	"error.session.expired": "Sitzung abgelaufen",
	"error.text.length.long": "Dieses Feld ist beschränkt auf {count} Figuren",
	"error.text.length.short": "Dieses Feld benötigt mindestens {count} Figuren",
	"error.user.verify.fail": "User verification failed",
	"error_profile_edit_member_approved": "Name und Geburtstag können nicht mehr geändert werden, nachdem Ihr Profil bestätigt wurde",
	"faq.contactEmailFallback": "Unsere Kontakt-E-Mail",
	"faq.contactPhoneFallback": "das Ende der Seite",
	"faq.other_question": "Können Sie die Antwort auf Ihre Frage nicht finden?",
	"file_upload_size_exceeded": "Die Datei ist zu groß. Maximale Größe: 5 MB",
	"footer.label.legal.information": "Rechtsinformation",
	"footer.label.personal.data": "persönliche Daten",
	"footer_callUs": "Rufen Sie uns an",
	"footer_other": "Sonstiges",
	"footer_share": "Folgen Sie uns",
	"footer_society_about": "Über uns",
	"footer_society_policy_privacy": "Datenschutzerklärung",
	"footer_society_term": "Nutzungsbedingungen",
	"footer_writeUs": "Schicken Sie uns eine E-Mail",
	"forgot_password.confirmation": "Ein Link zum Zurücksetzen Ihres Passworts wurde an Ihre E-Mail-Adresse gesendet.",
	"forgot_password.description_line1": "Geben Sie die zu Ihrem Konto gehörende E-Mail-Adresse ein.",
	"forgot_password.description_line2": "Wir werden Ihnen einen Link zum Zurücksetzen Ihres Passworts zusenden.",
	"forgot_password.submit": "Senden Sie mir den Reset-Link",
	"generic.address": "Adresse",
	"generic.at": "um",
	"generic.book": "Buch",
	"generic.cancel": "Stornieren",
	"generic.canceled": "Abgebrochen",
	"generic.city": "Ort",
	"generic.clear": "Aufheben",
	"generic.company": "Unternehmen",
	"generic.completed": "Abgeschlossen",
	"generic.country": "Land",
	"generic.email": "E-Mail-Adresse",
	"generic.end": "Ende",
	"generic.expires.at": "Läuft ab",
	"generic.extend": "Verlängern",
	"generic.file": "Datei",
	"generic.first.name": "Vorname",
	"generic.last.name": "Nachname",
	"generic.location.fixture.label": "Standorte",
	"generic.location.history.label": "Schadenshistorie",
	"generic.location.search.placeholder": "Suche nach einer Adresse, einem Ort...",
	"generic.mobile.phone": "Mobiltelefon",
	"generic.modify": "Ändern",
	"generic.mr": "Herr",
	"generic.mrs": "Frau",
	"generic.next": "Weiter",
	"generic.number": "Nummer",
	"generic.passport": "Reisepass",
	"generic.past.placeholder": "Hier finden Sie Ihre vergangenen Buchungen",
	"generic.phone.number": "Telefonnummer",
	"generic.postal.code": "Postleitzahl",
	"generic.retry": "Wiederholen",
	"generic.save": "Speichern",
	"generic.send": "Senden",
	"generic.start": "Start",
	"generic.text": "Text",
	"generic.today": "Heute",
	"generic.upcoming": "Zukunft",
	"generic.updated": "Aktualisiert",
	"generic.user": "Nutzer",
	"get.sso.config.fail": "This email address is not recognized for SSO login",
	"helpPage_carSharing_issue1_answer": "Zur Registrierung klicke einfach auf den entsprechenden Link auf der Website des Anbieters, um zum Registrierungsformular zu gelangen. Wenn du Hilfe benötigst kannst du dich gerne auch telefonisch oder per Mail an uns wenden.",
	"helpPage_carSharing_issue1_title": "Wie können Sie sich registrieren?",
	"helpPage_carSharing_issue2_answer": "Du kannst dein Passwort über die Webseite oder die mobilen Apps zurücksetzen. Du erhältst dann einen Link zum Zurücksetzen des Passworts an deine registrierte E-Mail-Adresse.",
	"helpPage_carSharing_issue2_title": "Was soll ich tun, wenn ich das Passwort vergessen habe?",
	"helpPage_carSharing_issue3_answer": "Falls du deinen Badge (Chip am Fahrzeugschlüsselanhänger) verlierst oder einen neuen erhalten hast, kontaktiere uns bitte telefonisch, um deinen Badge zurückzusetzen zu lassen. Ein neuer Badge wird erst nach dem Zurücksetzen funktionieren.",
	"helpPage_carSharing_issue3_title": "Was soll ich tun, wenn ich meinen Ausweis verloren oder einen neuen erhalten habe?",
	"helpPage_carSharing_issue4_answer": "Das Nummernschild deines Fahrzeugs wird in der Bestätigung-E-Mail und in der Bestätigungs-SMS genannt. Zusätzlich findest du das Fahrzeug auf der Buchungsseite \"Meine Buchungen\".",
	"helpPage_carSharing_issue4_title": "Welches Fahrzeug habe ich gebucht?",
	"helpPage_carSharing_issue5_answer": "Achte darauf, dass das Datum und die Uhrzeit stimmen. Der Startknopf steht erst ab dem gebuchten Zeitpunkt zur Verfügung. Ansonsten kannst du deinen Ausweis auf den Kartenleser halten, um die Fahrzeugtüren zu öffnen.",
	"helpPage_carSharing_issue5_title": "Warum kann ich den Startknopf nicht finden?",
	"helpPage_carSharing_issue6_answer": "Wenn du das Fahrzeug reserviert hast und das Licht grün leuchtet, aber die Tür nicht aufgeht, drücke bitte auf den Knopf am Türgriff.",
	"helpPage_carSharing_issue6_title": "Warum leuchtet das Licht grün, aber die Türen sind noch verschlossen?",
	"helpPage_carSharing_issue7_answer": "Sobald du das Fahrzeug gebucht hast, kannst du deine Reservierung auch auf der Webseite oder in der mobilen App bearbeiten oder stornieren. Falls du dabei Hilfe benötigst, kontaktiere uns bitte telefonisch.",
	"helpPage_carSharing_issue7_title": "Bearbeitung / Stornierung",
	"helpPage_carSharing_issue8_answer": "Du kannst das Fahrzeug erst zum gebuchten Zeitpunkt öffnen.",
	"helpPage_carSharing_issue8_title": "Kann ich das Fahrzeug im Voraus mit dem Ausweis öffnen?",
	"helpPage_damages_issue1_answer": "Bitte achte darauf, dass du uns Schäden am Fahrzeug über die mobile App bei Fahrtantritt mitteilst oder uns telefonisch mitteilst, bevor du deine Fahrt beginnst.",
	"helpPage_damages_issue1_title": "Was soll ich tun, wenn das reservierte Fahrzeug beschädigt ist?",
	"helpPage_damages_issue2_answer": "Bleib ruhig und stelle sicher, dass niemand verletzt wurde. Du genießt Versicherungsschutz. Bitte setze dich so schnell wie möglich mit uns in Verbindung, um weitere Anweisungen zu erhalten.",
	"helpPage_damages_issue2_title": "Was soll ich tun, wenn es während meiner gebuchten Fahrt zu einem Unfall kommt?",
	"helpPage_subtitle": "In diesem Abschnitt findest du Antworten auf die häufigsten Fragen (FAQ).",
	"helpPage_tab_carSharing": "Service",
	"helpPage_tab_damages": "Schäden",
	"helpPage_tab_vehicles": "Fahrzeug",
	"helpPage_title": "Häufig gestellte Fragen (FAQ)",
	"helpPage_vehicles_issue1_answer": "Prüfe die Daten und die Uhrzeit deiner gebuchten Fahrt und vergleiche das Nummernschild mit dem auf deiner Buchung. Halte anschließend NUR den Ausweis vor das Lesegerät. Stelle sicher, dass du den Ausweis der Person verwendest, die die Buchung getätigt hat und dass der Ausweis seit der letzten Buchung nicht ausgetauscht wurde. Falls der Ausweis in letzter Zeit getauscht worden ist, wende dich bitte an den  Kundendienst, der die Änderungen vornimmt.",
	"helpPage_vehicles_issue1_title": "Warum reagiert das Fahrzeug nicht?",
	"helpPage_vehicles_issue2_answer": "Prüfe die Daten und die Uhrzeit deiner gebuchten Fahrt und ob das Nummernschild mit deiner Buchung übereinstimmt. Stelle sicher, dass du den korrekten Ausweis hast (Ausweis der Person, die die Reservierung durchgeführt hat).",
	"helpPage_vehicles_issue2_title": "Warum leuchtet der Kartenleser nur rot?",
	"helpPage_vehicles_issue3_answer": "Wenn du ein Fahrzeug gebucht hast und das Licht grün leuchtet, die Türen sich aber nicht öffnen, drücke bitte den Knopf an der Fahrertür, um die Türen aufzuschließen.",
	"helpPage_vehicles_issue3_title": "Warum bleiben die Türen geschlossen?",
	"helpPage_vehicles_issue4_answer": "Bitte prüfe das Nummernschild des Fahrzeugs, das gebuchte Datum und die Uhrzeit und achte darauf, dass die Internetverbindung ausreichend ist.",
	"helpPage_vehicles_issue4_title": "Warum kann ich die Türen nicht öffnen?",
	"helpPage_vehicles_issue5_answer": "Bitte stelle sicher, dass der Motor abgeschalten ist, die Türen und der Kofferraum geschlossen sind und dass du die Schlüssel mit dem kleinen Chip in die Box im Handschuhfach gelegt hast.",
	"helpPage_vehicles_issue5_title": "Warum kann ich das Fahrzeug nicht abschließen?",
	"home.header_banner": "Im Oktober wird <strong> Renault Mobility </strong> zu <strong> Mobilize share </strong>",
	"home.welcome": "Willkommen bei {productName}",
	"home.welcome_solo": "Willkommen",
	"how_it_works.step_1": "<span class='bold'>Anwendung herunterladen</span> aus dem App Store oder aus Google Play.",
	"how_it_works.step_2": "Starten Sie die Anwendung und <span class='bold'>registrieren Sie sich,</span> indem Sie das Formular ausfüllen.",
	"how_it_works.step_3": "Machen Sie ein Bild Ihres <span class='bold'>Führerscheins</span>, Ihres <span class='bold'>Ausweises</span> und <span class='bold'>machen Sie ein Bild von sich,</span> mit Ihrem Ausweis neben Ihrem Gesicht und speichern Sie das alles in der App!",
	"how_it_works.step_4": "<span class='bold'>Registrieren Sie Ihre Bankkarte,</span> um die Zahlung Ihrer Mietwagen zu verwalten.",
	"how_it_works.step_5": "<span class='bold'>Bestätigen sie Ihre E-Mail-Adresse,</span> indem Sie auf den erhaltenen Link klicken. <span class='bold'>Überprüfen Sie Ihre SPAM-Ordner</span>.",
	"how_it_works.step_6": "Nachdem Ihre Registrierung bestätigt ist, <span class='bold'>reservieren Sie Ihr Fahrzeug</span> auf unserer Anwendung oder auf unserer Webseite. Am Tag Ihrer Reservierung <span class='bold'>ist Ihr Smartphone Ihr Schlüssel!</span>",
	"info.account.company.already.linked": "Dieses Unternehmen ist bereits mit Ihrem Konto verknüpft",
	"info.switch.profile": "<strong>New — </strong>You can now add and manage multiple profiles using the same credentials. This allows you to join corporate fleets of you company and use the same app to rent a vehicle for your week-ends.",
	"info.switching.profile": "Profil wechseln",
	"info.worldpay.return.success": "Zahlungsinformationen beigefügt",
	"iso__BE": "Belgien",
	"iso__CS": "Tschechien",
	"iso__DA": "Dänisch",
	"iso__DE": "Deutschland",
	"iso__ES": "Spanien",
	"iso__FR": "Frankreich",
	"iso__IT": "Italien",
	"iso__NL": "Niederlande",
	"iso__PL": "Polen",
	"iso__PT": "Portugal",
	"iso__SL": "Slowenien",
	"iso__SV": "Schweden",
	"iso__pt_BR": "Brasilien",
	"label.accept_terms_and_conditions": "Ich stimme zu, nachfolgend von Renault und dessen Netzwerk per E-Mail kontaktiert zu werden, zum Zwecke der Untersuchung oder Information über neue Produkte und aktuelle Angebote. Bei jeder Zusendung habe ich die Möglichkeit, jegliche Kommunikation zu beenden.",
	"label.account.already.active": "Ihr Konto ist bereits aktiv",
	"label.account_activation_description": "Sie erhalten eine Bestätigung per E-Mail, wenn Ihr Konto bestätigt ist und Sie dann alle Vorzüge des Dienstes genießen können.",
	"label.account_activation_title": "Ihr Konto wird in maximal 15 Minuten bestätigt.",
	"label.activation.link.expired": "Aktivierungs-Link ist abgelaufen",
	"label.activation.link.send": "Erneut senden",
	"label.activation.link.sent.success": "Die Aktivierungs-E-Mail wird gesendet, falls der Benutzer vorhanden und das Konto nicht aktiviert ist",
	"label.active.profile": "Aktives Profil",
	"label.actual.payment.method": "Ihre aktuelle Zahlungsmethode",
	"label.add.new.profile": "Neues Profil hinzufügen",
	"label.apply": "Anwenden",
	"label.are_you_sure_you_want_to_cancel": "Möchten Sie Ihre Stornierung bestätigen?",
	"label.birth.day": "Geburtsdatum",
	"label.booking": "Buchung",
	"label.booking.past": "Vergangene",
	"label.booking.past.placeholder": "Hier finden Sie Ihren Buchungsverlauf.",
	"label.booking.today.part": "Heute, um",
	"label.booking.upcoming.placeholder": "Hier finden Sie Ihre geplanten und laufenden Buchungen",
	"label.cancel_my_booking": "Meine Reservierung stornieren",
	"label.car": "fahrzeug",
	"label.carSharing": "Fahrgemeinschaft",
	"label.cars": "fahrzeuge",
	"label.civility": "Höflichkeit",
	"label.click_here": "Hier anklicken",
	"label.close": "Schließen",
	"label.confirm_new_password": "Passwort bestätigen",
	"label.congratulations": "Glückwunsch!",
	"label.continue": "Weiter",
	"label.creditCard_message": "Um Ihre Karte zu bestätigen, erfolgt eine temporäre Belastung. Die Belastung eines kleinen Betrages von {amountToTake} € kann kurzfristig auf dem zu Ihrer Karte gehörenden Konto erscheinen. Falls die Belastung für mehr als fünf Arbeitstage bestehen bleibt, kontaktieren Sie bitte Ihre Bank.",
	"label.date": "Datum",
	"label.delivery_place": "Stadt ausgeben",
	"label.driving_licence": "Führerschein",
	"label.driving_licence_back": "Führerschein (Rückseite)",
	"label.driving_licence_front": "Führerschein (Vorderseite)",
	"label.edit.invite.code": "Einladungscode bearbeiten",
	"label.expiration_date": "Ablaufdatum",
	"label.file.upload.only.mobile": "Bitte verwenden Sie die Mobil-App, um Dokumente zu ändern.",
	"label.filter_by": "Filtern nach",
	"label.filters": "Filter",
	"label.generic.error": "Ein Fehler ist aufgetreten. Bitte versuchen Sie es später nochmals.",
	"label.hours": "Stunden",
	"label.how_it_works": "Wie funktioniert es?",
	"label.identity.card": "Personalausweis",
	"label.identity.document.number": "Ausweisdokument-Nummer",
	"label.identity.document.type": "Ausweisdokumententyp",
	"label.identity_card": "Ausweisdokument",
	"label.identity_card_back": "Ausweisdokument (Rückseite)",
	"label.identity_card_front": "Ausweisdokument (Vorderseite)",
	"label.identity_card_selfie": "Selfie mit Ihrem Ausweisdokument",
	"label.invite_code_placeholder": "Geben Sie Ihren Einladungscode ein",
	"label.italy.fiscal.code": "Steuernummer eingeben",
	"label.italy.resident": "Sind Sie Italiener?",
	"label.licence_number": "Führerscheinnummer",
	"label.load_more": "Mehr Ergebnisse",
	"label.login": "Anmelden",
	"label.logout": "Abmelden",
	"label.manager.email": "E-Mail Ihres Managers",
	"label.mandatory_fields": "* Pflichtfelder",
	"label.member_already": "Bereits Mitglied?",
	"label.my_account": "Mein Konto",
	"label.my_reservations": "Meine Buchungen",
	"label.new.password": "Neues Passwort",
	"label.no_account": "Neues Mitglied?",
	"label.or_by_phone": "Oder per Telefon",
	"label.password": "Passwort",
	"label.password_forgot": "Passwort vergessen",
	"label.phone": "Telefon",
	"label.phone.suffix": "Telefondurchwahl",
	"label.plateNumber": "Kennzeichen",
	"label.price": "Preis",
	"label.redirectMobileApp": "Laden Sie unsere Mobil-App herunter, um Ihre Buchung zu starten!",
	"label.remember_me": "Angemeldet bleiben",
	"label.reset_password_done": "Ihr Passwort wurde aktualisiert",
	"label.return": "Zurück",
	"label.schedule": "Stunden",
	"label.search": "Suche",
	"label.selected.language": "Ausgewählte Sprache",
	"label.subject": "Betreff",
	"label.switch.profile": "Profil wechseln",
	"label.the": "bis",
	"label.validate": "Bestätigen",
	"label.vehicles_found": "{count} Ergebnisse gefunden",
	"label.warning": "Warnung",
	"label.welcome.finish.registration": "Um Ihren Termin zu bestätigen, beenden Sie bitte Ihre Registrierung.",
	"label.you_are_trying_to_cancel_your_booking": "Sie sind dabei, Ihre Reservierung zu stornieren!",
	"label.your.active.profile": "Ihr aktives Profil",
	"label.your.other.profiles": "Ihre anderen Profile",
	"label.your_message": "Ihre Nachricht",
	"language.header": "Wählen Sie Ihre Sprache aus",
	"login.forgot_password": "Passwort vergessen?",
	"login.register": "Registrieren",
	"menu.faq": "Info",
	"mobile_banner.text": "Laden Sie die Anwendung {productName} herunter",
	"page.password.update.sub.title": "Aus Sicherheitsgründen bitten wir Sie Ihr Passwort zu aktualisieren",
	"page.password.update.title": "Passwort-Update",
	"parking.special_opening_legend": "Besondere Öffnungszeiten",
	"part.company.fill.extra.info": "fordert Sie auf, einige zusätzliche Informationen einzugeben.",
	"part.complete.register.for": "Schließen Sie Ihre Registrierung ab, bei",
	"part.create.account.for": "Erstellen Sie ein Konto für",
	"part.link.account.to": "Verknüpfen Sie Ihr Konto mit",
	"part.your.email": "deine email",
	"placeholder.enter.number": "Geben Sie eine Nummer ein ...",
	"placeholder.enter.text": "Geben Sie hier ein ...",
	"placeholder.search": "Suche ...",
	"profile.422.error.info": "Es sieht so aus, als ob einige Informationen in Ihrem Profil fehlen.\n Lassen Sie uns gemeinsam Ihr Profil überprüfen, um sicherzustellen, dass alles in Ordnung ist.",
	"profile.info.new.email": "Falls Sie Ihre E-Mail-Adresse aktualisieren, erhalten Sie eine E-Mail zur Überprüfung Ihrer E-Mail-Adresse. Ohne deren Überprüfung können Sie keine Buchung mehr erstellen.",
	"profile.label.before.arrival": "Vor der Ankunft",
	"profile.label.before.departure": "Vor der Abfahrt",
	"profile.label.charges.call.center": "Für Änderungen, die unser Support für dich durchgeführt hat",
	"profile.label.charges.my": "Für Änderungen, die ich vornehme",
	"profile.label.current.password": "Aktuelles Passwort",
	"profile.label.expiration.date.status": "Mein Führerschein hat kein Ablaufdatum",
	"profile.label.min.15": "15 Minuten",
	"profile.label.min.30": "30 Minuten",
	"profile.label.min.45": "45 Minuten",
	"profile.label.new.email": "Neue E-Mail-Adresse",
	"profile.label.street.field": "Adresse (Straßenname + Hausnummer)",
	"profile.label.validated.email": "Ihre bestätigte E-Mail-Adresse",
	"profile.section.additional.info": "Zusätzliche Information",
	"profile.section.credentials": "Anmeldedaten",
	"profile.section.language": "Profilsprache",
	"profile.section.notifications": "Benachrichtigungen und Warnungen",
	"profile.section.payment.info": "Zahlungsinformationen",
	"profile.section.personal.info": "Personenbezogene Daten",
	"profile.section.selfie": "Selfie",
	"profile.section.technician.access": "Technikerzugang",
	"profile.select.menu.item": "Bitte wählen Sie ein Element aus dem Menü links",
	"profile.selfie.section.info": "Bitte machen Sie ein Selfie, das Ihren Ausweis neben Ihrem Gesicht zeigt.",
	"profile.suspended": "Dein Profil ist gesperrt",
	"profile.title.email.notifications": "Benachrichtigungen per E-Mail",
	"profile.title.language.select": "Sprache für Benachrichtigungen und E-Mails",
	"profile.title.sms.notifications": "SMS-Benachrichtigungen",
	"profile.title.update.email": "Aktualisieren Sie Ihre E-Mail-Adresse",
	"profile.title.update.password": "Aktualisieren Sie Ihr Passwort",
	"profile_error_driver_license_invalid": "Der Führerschein ist ungültig",
	"register.field.info.password": "Muss mindestens 1 Zahl, 1 Großbuchstaben, 1 Kleinbuchstaben und zwischen 8 und 25 Zeichen enthalten",
	"register.info.payment.saved": "Zahlungsmethode wurde gespeichert.",
	"register.info.profile.creation.forbidden": "You can't link your profile to this company",
	"register.success.info": "Ein Aktivierungslink wurde an {email} geschickt. Bitte prüfen Sie Ihre E-Mails und Ihren Spam-Ordner, befolgen Sie dann die Anweisungen zur Aktivierung Ihres Kontos, bevor der Link abläuft.",
	"register.terms.ads": "Ich stimme der Verarbeitung meiner Daten für Marketingzwecke (sowohl mit automatisierten als auch traditionellen Methoden) in Bezug auf Mobilitätsprodukte und/oder -dienstleistungen zu.",
	"register.terms.prefix.accept": "Ich akzeptiere die",
	"register.terms.privacy.link.label": "Privacy policy",
	"register.terms.privacy.text": "I accept the {link} of {company}",
	"register.terms.root.privacy": "Datenschutzerklärung",
	"register.terms.root.tos": "Abonnementbedingungen",
	"register.terms.root.tou": "Nutzungsbedingungen",
	"register.terms.suffix.ads": "Verwendung meiner Daten für kommerzielle Zwecke",
	"register.terms.suffix.of": "von",
	"register.terms.usage.link.label": "Terms of use",
	"register.terms.usage.subscription.link.label": "Terms of subscription",
	"register.terms.usage.subscription.text": "I accept the {link} of {company}",
	"register.terms.usage.text": "I accept the {link} of {company}",
	"register.title.account.created": "Glückwunsch {firstName}, Ihr Konto wurde erstellt",
	"register.title.account.linked": "Herzlichen Glückwunsch {firstName}, neues Profil wurde mit Ihrem Konto verknüpft",
	"register.title.account.updated": "Glückwunsch {firstName}, Ihr Konto wurde aktualisiert",
	"reset_password.title": "Passwort zurücksetzen",
	"search.filter_alphabetically": "Alphabetisch",
	"search.filter_by": "Sortieren nach",
	"search.filter_by_price": "Nach Preis",
	"search.result.empty": "Es gibt kein Ergebnis",
	"service.corporate.intro": "Sie möchten einer Community beitreten? Bitte geben Sie Ihren Einladungscode ein.",
	"service.intro_label": "Welchen {productName}-Service möchten Sie abonnieren?",
	"service.private.intro": "Sie möchten ein Fahrzeug aus dem {productName}-Netzwerk buchen?",
	"service.private.renaultfr": "Um {productName} zu abonnieren, laden Sie bitte die App aus Ihrem App Store herunter.",
	"service.private.select_country": "Bitte wählen Sie ein Land aus",
	"service.usage.corporate": "Geschäftliches Car-Sharing",
	"service.usage.private": "Rund um die Uhr-Autoanmietung",
	"service.usage.vr": "Ersatzfahrzeug",
	"service.vr.intro": "Vielen Dank für Ihr Interesse an unserem Service!\n\nUm Abonnent zu werden, kontaktieren Sie bitte Ihren Händler, um einen Registrierungs-Link zu erhalten.",
	"sncf.home.login.msg": "Are you an SNCF employee? Log in.",
	"sso.login.description": "Geben Sie Ihre geschäftliche E-Mail-Adresse ein",
	"sso.login.title": "Mit SSO verbinden",
	"status.APPROVED": "Profil validiert",
	"status.NOT_APPROVED": "Ihr Profil wird abgelehnt. Bitte aktualisieren Sie Ihr Profil.",
	"status.TO_COMPLETE": "Unvollständig",
	"status.TO_REVIEW": "Die Validierung Ihres Profils steht aus",
	"tagline": "Rund um die Uhr-Autoanmietung per Selbstbedienung",
	"title.add.payment.later": "Sie können es später hinzufügen.",
	"title.add.payment.method": "Bitte fügen Sie eine Zahlungsmethode hinzu.",
	"title.bookings.welcome.tutorial": "Finden Sie hier Ihre Buchung, sie ist bereits geplant",
	"title.modify.booking": "Meine Buchung ändern",
	"title.password.change.success": "Ihr neues Passwort wurde gespeichert",
	"title.update.booking": "Update-Buchung",
	"title.welcome.to.brand": "Hallo {firstName}, willkommen bei {brandName}.",
	"title.welcome.to.program": "Hallo {firstName}, willkommen im {brandName} {program}.",
	"vehicle.incorrect.usage": "Das Fahrzeug ist für diese Verwendungsart nicht verfügbar",
	"week.day.friday": "Freitag",
	"week.day.monday": "Montag",
	"week.day.saturday": "Samstag",
	"week.day.sunday": "Sonntag",
	"week.day.thursday": "Donnerstag",
	"week.day.tuesday": "Dienstag",
	"week.day.wednesday": "Mittwoch"
};


/*****************
 ** WEBPACK FOOTER
 ** ./src/i18n/de.json
 ** module id = 420
 ** module chunks = 0
 **/